import { render } from "./NewPage.vue?vue&type=template&id=a684711c&scoped=true"
import script from "./NewPage.vue?vue&type=script&lang=js"
export * from "./NewPage.vue?vue&type=script&lang=js"

import "./NewPage.vue?vue&type=style&index=0&id=a684711c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a684711c"]])

export default __exports__